import PropTypes from 'prop-types';
import { useEffect } from 'react';

export const GlobalLoading = ({ messages = ['Loading...'], currentStep = 0 }) => {
    useEffect(() => {
        // Prevent scrolling while loading is displayed
        document.body.style.overflow = 'hidden';

        // Cleanup function to restore scrolling when unmounted
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    return (
        <div className="fixed top-0 left-0 right-0 bottom-0 backdrop-blur-sm bg-white/30 flex flex-col items-center justify-center z-[99999] pointer-events-auto">
            <div className="flex flex-col items-center gap-4">
                <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 border-t-primary-blue border-b-primary-blue"></div>
                <div className="flex flex-col items-center gap-2 relative w-full">
                    {messages.map((message, index) => (
                        <div
                            key={index}
                            className={`w-full absolute top-0 left-0 right-0 flex items-center justify-center transition-opacity duration-500 ${
                                index === currentStep ? 'opacity-100' : 'opacity-0'
                            }`}
                        >
                            <p className="text-gray-700 font-medium text-lg whitespace-nowrap">
                                {message}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

GlobalLoading.propTypes = {
    messages: PropTypes.arrayOf(PropTypes.string),
    currentStep: PropTypes.number,
};
